import { createRoot } from 'react-dom/client';
import { initializeAppEnvironment } from '@/shared/lib/runtimeEnvironment';
import App from '@/app/App';
import { StoreProvider } from '@/app/providers/StoreProvider/ui/StoreProvider';

const shouldReloadOnChunkError = (error: unknown): boolean => {
  const message = String((error as any)?.message ?? error ?? '');
  if (!message) {
    return false;
  }

  return (
    message.includes('ChunkLoadError') || message.includes('Loading chunk') || message.includes('Unexpected token')
  );
};

const chunkReloadKey = 'chunk_reload_once';

const reloadOnChunkError = (payload: unknown) => {
  if (!shouldReloadOnChunkError(payload)) {
    return;
  }

  if (sessionStorage.getItem(chunkReloadKey) === '1') {
    return;
  }

  sessionStorage.setItem(chunkReloadKey, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  reloadOnChunkError((event as any)?.error ?? (event as any)?.message);
});

window.addEventListener('unhandledrejection', (event) => {
  reloadOnChunkError((event as any)?.reason);
});

const root = createRoot(document.getElementById('root') as HTMLElement);

void initializeAppEnvironment().then(() => {
  root.render(
    <StoreProvider>
      <App />
    </StoreProvider>,
  );
});
